<template>
    <div class="help">
        <Title title="帮助中心" path="/my"/>
        <div class="fxboex abfxnav">
            <van-tabs v-model="nav_active">
                <van-tab v-for="(c, i) in navs" :key="i" :title="c"/>
            </van-tabs>
        </div>

<!--        <div class="fxboex abfxnav">-->
<!--            <div v-for="(c,i) in navs" :key="i" :class="nav_active===i?'curr':''" @click="changeNav(i)">{{c}}</div>-->
<!--        </div>-->

        <div class="helpcon">

            <div class="helpitem" id="help1">
                <div class="helpitem-con helplc">
                    <h3><span>消费流程</span></h3>
                    <div>
                        <p class="fB">1. <a href="/register">注册</a>成为烽行体育会员（会员可优先查看免费单场贴士）。</p>
                        <p class="fB">2. 登陆平台会员区进入“在线充值”页面中获取充值端口，充值金额后获得相应的FXB(烽行币)。</p>
                        <p class="fB">3. 进入专家预测列表，选择需要订阅的赛事预测。</p>
                        <p class="fB">4. 确定好需要订阅的赛事预测，按照所显示的价格，点击"订阅"或"查看"，确认提示，系统自动扣除会员相应FXB烽行币，即可查看预测的内容。（请确保足够点数订阅本场预测，提前充值好FXB烽行币）</p>
                    </div>
                </div>
            </div>

            <div class="helpitem" id="help2">
                <div class="helpitem-con helpds">
                    <h3><span>什么是FXB？</span></h3>
                    <div>
                        FXB是本平台专用代币，称“烽行币”用于订阅专家预测收费项目，充值比例<span class="red">1元＝1FXB</span>。
                    </div>
                </div>
            </div>

            <div class="helpitem" id="help3">
                <div class="helpitem-con helpds">
                    <h3><span>什么是积分？</span></h3>
                    <div>
                        <p>积分是烽行体育对线上用户的一种奖励。根据用户的使用服务、签到、活跃度等情况，通过累计积分的方式推出的一项长期回馈计划。</p>
                        <p><span class="red">1积分</span>可抵扣<span class="red">1FXB</span>。</p>
                    </div>
                </div>
            </div>

            <div class="helpitem" id="help4">
                <div class="helpitem-con helpxx">
                    <h3><span>不中返还，信心保证！</span></h3>
                    <div>
                        <p>为保障用户订阅专家预测的权益，推出"不中100%全额返还"保障服务。</p>
                        <p>如订阅某专家预测赛事中含有“不中100%返还”时，即可享受平台保障服务。</p>
                        <p>当订阅专家预测赛事的结果为平、负或取消等情况时，平台将24小时内将对应金额返还到你的账户上，如超时未返还到账可以联系本站微信或电话客服。</p>
                        <p>使用优惠券订阅专家预测的订单，若发生不中返还，订阅单个专家预测的优惠，按实际支付金额返还；订阅多个专家预测的优惠，按专家预测售价所占订单金额比例等额拆分实际支付金额进行返还。</p>
                    </div>
                </div>
            </div>

            <div class="helpitem" id="help5">
                <div class="helpitem-con helpxx">
                    <h3><span>什么是优惠券</span></h3>
                    <div>
                        <p>一、什么是优惠券</p>
                        <p>优惠券是本站通过线上活动、推广活动等形式发放给用户，用于减免支付金额的优惠措施。</p>
                        <p>满减券是用来直接减免部分订单金额的优惠券。满减券的使用受订单总金额的限制。订单必须符合满减券的使用条件才可使用。</p>
                        <p>比如：消费满500FXB减50FXB代金券，需要在订单金额中，消费金额大于等于500FXB时才可减免50FXB。</p>
                        <p></p>
                        <p>温馨提示：</p>
                        <p>加入购物车合并订单支付可使用大额优惠券，“优惠券”可以和“积分抵扣”同时使用。</p>
                        <p></p>
                        <p>二、优惠券使用细则</p>
                        <p>1、优惠券适用于在本站注册的个人会员;</p>
                        <p>2、每张优惠券仅能使用一次，不能兑换现金，不找零，不退换；</p>
                        <p>3、优惠券应在券面标示或系统显示的有效期内使用，过期作废;</p>
                        <p>4、使用优惠券订阅专家预测的订单，若发生不中返还，订阅单个专家预测的优惠，按实际支付金额返还；订阅多个专家预测的优惠，按专家预测售价所占订单金额比例等额拆分实际支付金额进行返还。</p>
                        <p>5、本规则由本站依据国家相关法律法规及规章制度予以解释。</p>
                    </div>
                </div>
            </div>
            <div class="helpitem" id="help6">
                <div class="helpitem-con helpcz">
                    <h3><span>充值方式</span></h3>
                    <div>
                        <p>1.数字货币（USDT）在线充值实时到账</p>
                        <p>2.支付宝、微信在线充值实时到账</p>
                        <p>3.支付宝、微信、paypal转账</p>
                        <p>4.银行汇款（支持建设、工商、农业等)</p>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import Title from '../public/title'
    export default {
        name: "help",
        components: {
          Title
        },
        data() {
            // let vm = this
            return {
                tel: this.$getContactTel(),
                navs: ['消费流程', '什么是FXB', '会员积分', '不中返还', '什么是优惠券', '充值方式'],
                nav_active: 0
            }
        },
        watch: {
            nav_active(i){
                let id = 'help'+(i+1)
                let elemnt = document.getElementById(id)
                document.querySelector('#help'+(i+1)).scrollIntoView({behavior: 'smooth'})
                window.scrollTo(0, elemnt.offsetTop - 95);
            }
        },
        activated() {
            // this.tel = this.$getContactTel()
            this.$backTop()
        },
        methods: {

        },
    }
</script>

<style scoped>
/*.help{height:calc(100vh - 100px);overflow-y: auto;}*/
</style>
